import script from "./OrderPending.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderPending.vue?vue&type=script&setup=true&lang=ts"

import "./OrderPending.vue?vue&type=style&index=0&id=1c2b736a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c2b736a"]])

export default __exports__